import { ISliderStyles, IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, Sizes } from '../../themes/styles';

export interface ISliderContainerStyles {
  root: IStyle;
  customLabelContainer: IStyle;
  customLabel: IStyle;
  minMaxLabel: IStyle;
  minLabel: IStyle;
  maxLabel: IStyle;
  textField: IStyle;
  input: IStyle;
}

export interface ISliderContainerClassNames {
  root: string;
  customLabelContainer: string;
  customLabel: string;
  minMaxLabel: string;
  minLabel: string;
  maxLabel: string;
  textField: string;
  input: string;
}

export const sliderContainerStylesDefault = (theme: IH2OTheme): Partial<ISliderContainerStyles> => ({
  root: {
    position: 'relative',
  },
  customLabelContainer: {
    position: 'relative',
    height: 17,
  },
  customLabel: {
    position: 'absolute',
    top: 12,
  },
  minMaxLabel: {
    display: 'flex',
    div: {
      flex: 1,
      color: theme.semanticColors?.textSecondary,
      fontSize: FontSizes.xxsmall,
    },
  },
  minLabel: {},
  maxLabel: {
    textAlign: 'right',
  },
  textField: { position: 'absolute', right: 0, width: 50 },
  input: {
    textAlign: 'right',
    color: theme.palette?.gray900,
    fontSize: FontSizes.input,
    lineHeight: Sizes.height - 2,
    display: 'inline-block',
    width: '100%',
    border: `1px solid ${theme.semanticColors?.inputBorder}`,
    borderRadius: Sizes.borderRadius,
    paddingLeft: 0,
    paddingRight: Sizes.padding,
    outline: 'none',
    ':disabled': {
      pointerEvents: 'none',
      borderColor: theme.semanticColors?.inputDisabledBorder,
    },
    ':hover': {
      borderColor: theme.semanticColors?.inputActiveBorder,
    },
    ':focus': {
      borderColor: theme.semanticColors?.inputActiveBorder,
    },
    '::-webkit-outer-spin-button, ::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
});

export const sliderStylesDefault = (theme: IH2OTheme): Partial<ISliderStyles> => ({
  root: {
    paddingTop: 15,
    '&.ms-Slider-disabled': {
      pointerEvents: 'none',
      '.ms-Slider-thumb, .ms-Slider-active, .ms-Slider-inactive': {
        backgroundColor: theme.semanticColors?.inputDisabledBorder,
      },
    },
  },
  titleLabel: {
    color: theme.semanticColors?.textQuaternary,
  },
  slideBox: {
    padding: 0,
    height: 24,
    lineHeight: 24,
    ':hover, :active': {
      '.ms-Slider-thumb': {
        border: 0,
        backgroundColor: theme.semanticColors?.inputActiveBorder,
      },
      '.ms-Slider-active': {
        backgroundColor: theme.semanticColors?.inputActiveBorder,
      },
    },
  },
  activeSection: {
    backgroundColor: theme.palette?.primary500,
  },
  inactiveSection: {
    backgroundColor: theme.palette?.gray300,
  },
  thumb: {
    border: 0,
    backgroundColor: theme.palette?.primary500,
  },
});
